import { render, staticRenderFns } from "./courseDiscussion.vue?vue&type=template&id=4cb294c0"
import script from "./courseDiscussion.vue?vue&type=script&lang=js"
export * from "./courseDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports